import React, { FunctionComponent, ReactNode } from "react";
import { Layout, Menu } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { push, CallHistoryMethodAction } from "connected-react-router";
import { connect } from "react-redux";
import { StoreType } from "../../redux/store";
import {
  ROOT_PATH,
  DATE_RANGE_COMPARISON_PATH,
  ADS_AND_SMBS_PATH,
  WTD_MTD_QTD_PATH,
  AD_TRACKER_ORIGAMI,
  AD_TRACKER_LEGACY,
  ADS_PAST_SLA,
  PIXEL_TREE,
} from "../../routing/paths";
import "./index.scss";
import { ClickParam } from "antd/lib/menu";
import destroySessions, {
  DestroySession,
} from "../../redux/actions/sessions/destroySession";

const { SubMenu } = Menu;

type OutlineProps = {
  pathname: string;
  children: ReactNode;
  push: (path: string) => CallHistoryMethodAction;
  logout: DestroySession;
  logged: boolean | null;
};

const Outline: FunctionComponent<OutlineProps> = ({
  pathname,
  children,
  push,
  logout,
  logged,
}: OutlineProps) => {
  const renderLayout = () => {
    if (!logged)
      return (
        <Layout>
          <Layout.Content>{children}</Layout.Content>
        </Layout>
      );

    const onClick = ({ key }: ClickParam) => {
      if (key === "logout") logout();
      else push(key);
    };
    const selectedKey = () =>
      pathname === "" ? window.location.hash.replace("#", "") : pathname;
    return (
      <Layout className="outline">
        <Layout.Header> Welcome to the OwnLocal Report Tool </Layout.Header>
        <Layout>
          <Layout.Sider width={220}>
            <Menu
              theme="dark"
              mode="inline"
              selectedKeys={[selectedKey()]}
              onClick={onClick}
            >
              <Menu.Item key={ROOT_PATH}>Fulfillment Team Items</Menu.Item>
              <Menu.Item key={DATE_RANGE_COMPARISON_PATH}>
                Date Range Comparison
              </Menu.Item>
              <Menu.Item key={ADS_AND_SMBS_PATH}>Ads and SMBs</Menu.Item>
              <Menu.Item key={WTD_MTD_QTD_PATH}>WTD/MTD/QTD</Menu.Item>
              <SubMenu key="sub1" title="Origami and Legacy Ads">
                <Menu.Item key={AD_TRACKER_ORIGAMI}>Ad Tracker - Origami</Menu.Item>
                <Menu.Item key={AD_TRACKER_LEGACY}>Ad Tracker - Legacy</Menu.Item>
              </SubMenu>
              <Menu.Item key={ADS_PAST_SLA}>Ads Past SLA</Menu.Item>
              <Menu.Item key={PIXEL_TREE}>Pixel Tree</Menu.Item>
              <Menu.Item key="logout" className="logout-menu-item">
                <LogoutOutlined /> LogOut
              </Menu.Item>
            </Menu>
          </Layout.Sider>
          <Layout>
            <Layout.Content>{children}</Layout.Content>
          </Layout>
        </Layout>
      </Layout>
    );
  };

  return renderLayout();
};

const mapDispatchToProps = {
  push,
  logout: destroySessions,
};

const mapStateToProps = ({
  router: {
    location: { pathname },
  },
  auth: { logged },
}: StoreType) => ({ pathname, logged });

export default connect(mapStateToProps, mapDispatchToProps)(Outline);
